import * as React from 'react';
import { SVGProps } from 'react';

const IconLogicalElementSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M11 4H6v2H1v2h5v8H1v2h5v2h5a8.001 8.001 0 0 0 7.938-7H23v-2h-4.062A8.001 8.001 0 0 0 11 4z" />
  </svg>
);
export default IconLogicalElementSizeM;
